import { useDispatch, useSelector } from "react-redux";
import { loadCredits, loadCurrentCredits, setPage } from "~/slices/creditsSlice";
import type { AppDispatch, RootState } from "~/store";

export const useCredits = () => {
  const dispatch: AppDispatch = useDispatch();
  const credits = useSelector((state: RootState) => state.credits.list);
  const currentCredits = useSelector((state: RootState) => state.credits.currentList);
  const loading = useSelector((state: RootState) => state.credits.loading);
  const error = useSelector((state: RootState) => state.credits.error);
  const totalCount = useSelector((state: RootState) => state.credits.totalCount);
  const page = useSelector((state: RootState) => state.credits.page);
  const limit = useSelector((state: RootState) => state.credits.limit);

  const fetchCredits = (page: number, limit: number) => {
    dispatch(loadCredits({ page, limit }));
  };

  const fetchCurrentCredits = () => {
    dispatch(loadCurrentCredits());
  };

  const changePage = (newPage: number) => {
    dispatch(setPage(newPage));
    fetchCredits(newPage, limit);
  };

  return {
    dispatch,
    credits,
    currentCredits,
    loading,
    error,
    totalCount,
    page,
    limit,
    changePage,
    fetchCredits,
    fetchCurrentCredits,
  };
};
